import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f5c78b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "process" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "title ft-w-6" }


import { t } from '@/plugins/i18n'

export default /*#__PURE__*/_defineComponent({
  props: ['records', 'node'],
  emits: ['pick'],
  setup(__props, { emit }) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.node?.finish)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.records, (v, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: v.id,
            onClick: ($event: any) => (emit('pick', v)),
            class: "animated slideInRight step"
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", null, _toDisplayString(i + 1) + ". ", 1),
              _createElementVNode("span", null, _toDisplayString(_unref(t)(v.title)), 1)
            ])
          ], 8, _hoisted_2))
        }), 128))
      : _createCommentVNode("", true)
  ]))
}
}

})